<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <textarea
                ref="input"
                v-model="model"
                class="form-control form-control-noresize"
                autocomplete="off"
                :class="inputClass"
                :name="name"
                :required="required"
                :maxlength="maxlength"
                v-bind="$attrs" />

            <p v-if="maxlength" class="small text-right help-block mb-0">
                {{ length }} / {{ maxlength }}
            </p>
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';

export default {
    name: 'TextareaField',

    components: {FormGroup},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: String, default: null},
        maxlength: {type: [String, Number], default: undefined},
    },

    computed: {
        length() {
            return String(this.value || '').length;
        },
    },
};
</script>

<style scoped>
.form-control-noresize {
    resize: none;
}
</style>
